import React, { useState, useEffect } from "react";
import prev from "../imgs/previous.png"
import next from "../imgs/next.png"

export default function Location() {
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState(false);
  const [allLocation, setAllLocation] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [isLocationModalOpen, setIsLocationModalOpen] = useState(false);

  const getLocations = async (page, name = "") => {
    setLoading(true);
    const res = await fetch(`https://rickandmortyapi.com/api/location/?page=${page}&name=${name}`);
    const data = await res.json();
    setAllLocation(data.results || []);
    setTotalPages(data.info?.pages || 0);
    setLoading(false);
  };

  useEffect(() => {
    getLocations(currentPage, searchTerm);
  }, [currentPage, searchTerm]);

  const handleSearchChange = (event) => {
    const term = event.target.value;
    setSearchTerm(term);
    event.preventDefault();
    setCurrentPage(1);

    if (term === "") {
      getLocations(1);
    } else {
      getLocations(1, "", term);
    }
  };

  const handleSearchSubmit = (event) => {
    event.preventDefault();
    setCurrentPage(1);

    if (searchTerm === "") {
      getLocations(1);
    } else {
      getLocations(1, "", searchTerm);
    }
  };

  const handlePrev = () => {
    const prevPage = currentPage - 1;
    if (prevPage >= 1) {
      setCurrentPage(prevPage);
      getLocations(prevPage, "", searchTerm);
    }
  };

  const handleNext = () => {
    const nextPage = currentPage + 1;
    if (nextPage <= totalPages) {
      setCurrentPage(nextPage);
      getLocations(nextPage, "", searchTerm);
    }
  };

  const handleLocationClick = (location) => {
    setSelectedLocation(location);
    setIsLocationModalOpen(true);
  };

  const closeLocationModal = () => {
    setIsLocationModalOpen(false);
    setSelectedLocation(null);
  };

  const filteredLocations = allLocation.filter(location =>
    location.name.toLowerCase().includes(searchTerm.toLowerCase())
  ).sort((a, b) => a.name.localeCompare(b.name));

  useEffect(() => {
    if (isLocationModalOpen) {
      document.body.classList.add("modal-open");
    } else {
      document.body.classList.remove("modal-open");
    }
  }, [isLocationModalOpen]);

  return (
    <div className="location-container">
      <h2 className="title">Rick and Morty</h2>
      <h4 className="route">Locations</h4>
      <form onSubmit={handleSearchSubmit}>
        <input
          className="search"
          type="search"
          placeholder="Search"
          autoComplete={true}
          value={searchTerm}
          onChange={handleSearchChange}
        />
        <button type="submit" className="search-button">Search</button>
      </form>
      <div className="planet-container">
        <img className="location-img" src="https://rickandmortyapi.com/api/character/avatar/1.jpeg" alt="cover" />
        {loading ? (
          <div className="loader"></div>
        ) : filteredLocations.length === 0 ? (
          <div className="no-characters">No such location as "{searchTerm}".</div>
        ) : (
          filteredLocations.map(location => (
            <div
              className="location-planet"
              key={location.id}
              style={{ cursor: 'pointer' }}
              onClick={() => handleLocationClick(location)}
            >
              <h4 className="planet-top">{location.name}</h4>
              <span className="planet-bottom">{location.type}</span><br />
              <span className="planet-bottom">{location.dimension}</span>
              <h4 className="planet-top">Characters-Present: {location.residents.length}</h4>
            </div>
          )))}
      </div>
      <div className="buttons">
        <img className="button" src={prev} alt="previous" onClick={handlePrev} />
        <div className="display">{currentPage}</div>
        <img className="button" src={next} alt="next" onClick={handleNext} />
      </div>
      {isLocationModalOpen && (
        <div className="location-modal-content">
          <span className="close" onClick={closeLocationModal}>&times;</span>
          {selectedLocation && (
            <>
              <h2 className="location-title">Residents of {selectedLocation.name}</h2>
              <ul>
                {selectedLocation.residents.map((resident, index) => (
                  <li key={index}><a href={resident} target="_blank">{resident}</a></li>
                ))}
              </ul>
            </>
          )}
        </div>
      )}
    </div>
  )
}